module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-2-preview-be0bf8615fa2cdc59f7fbd14c0f4993c.jpg";